import { render, staticRenderFns } from "./CharacterWord.vue?vue&type=template&id=782252b1&scoped=true"
import script from "./CharacterWord.vue?vue&type=script&lang=js"
export * from "./CharacterWord.vue?vue&type=script&lang=js"
import style0 from "./CharacterWord.vue?vue&type=style&index=0&id=782252b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782252b1",
  null
  
)

export default component.exports